import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { toast } from "../../Utills/toast";
import "./Table.css";
import LiveOrder from "./LiveOrder";
import TableBillPage from "./TableBillPage"
import OrderPage from "../Bill";
import MenuPage from "../../pages/MenuPage";
import OrderHistory from "./OrderHistory";
import BackButton from "../../component/BackButton/BackButton";

const Table = () => {
  const [activeTab, setActiveTab] = useState("liveOrder");
  const notifications = useSelector((state) => state.notifications.list);
  const navigate = useNavigate();
  const { tableName, otp } = useParams(); // ✅ gets the OTP from URL 
  const latestNotification = notifications[0];
  const isTablePaid = latestNotification?.type === "PAYMENT_DONE" && latestNotification.tableOtp === otp;

  useEffect(() => {

    // ✅ 1. Only act if it's a PAYMENT_DONE type
    if (latestNotification?.type === "PAYMENT_DONE") {

      // ✅ 2. IMPORTANT: Only redirect if the payment is for the table currently open
      // This prevents staff from being redirected while working on a different table.
      if (latestNotification.tableOtp === otp) {

        // toast is usually imported from 'react-toastify'
        toast.success(`Table ${latestNotification.tableNumber} bill settled! Returning to Table View...`);

        const timer = setTimeout(() => {
          navigate('/tables');
        }, 9500);

        return () => clearTimeout(timer);
      }
    }
  }, [notifications.length, navigate, otp]);

  const tabs = [
    { id: "liveOrder", label: "🧊 Live Order" },
    { id: "orderHistory", label: "📜 Order History" },
    { id: "orderItems", label: "🍽️ Place Order" },
    // { id: "reservation", label: "🗓️ Reservation" },
    { id: "generateBill", label: "💳 Generate Bill" },
  ];

  const renderContent = () => {

    if (isTablePaid) {
      return (
        <div className="settled-view">
          <div className="success-check">✓</div>
          <h2>Table {tableName} Settled</h2>
          <p>The payment was successful. Redirecting you shortly...</p>
        </div>
      );
    }

    switch (activeTab) {
      case "liveOrder":
        return <LiveOrder tableOtp={otp} />;
      case "orderHistory":
        return <OrderHistory tableOtp={otp} />;
      //return <OrderPage />;
      case "orderItems":
        return <MenuPage />;
      case "reservation":
        return <div>📅 Reservation content goes here</div>;
      case "generateBill":
        return <TableBillPage tableOtp={otp} />;
      default:
        return null;
    }
  };

  return (
    <div className="table-page">
      <div className="header-bar">

        <div className="table-tabs">
          {/* <span className="back-btn" onClick={() => navigate(-1)}>← Back</span> */}
          <BackButton to="/tables" label="Back to Menu" variant="subtle" />
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="tab-content">{renderContent()}</div>
    </div>
  );
};


export default Table;


